module.exports = __webpack_public_path__ + "static/media/logoPrinterConnect.d2606a84.png";